/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_LabelInputs */

const en_fc_vs_label = /** @type {(inputs: Fc_Vs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison`)
};

/**
* | output |
* | --- |
* | "Comparison" |
*
* @param {Fc_Vs_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_label = /** @type {((inputs?: Fc_Vs_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_label(inputs)
});
export { fc_vs_label as "fc.vs.label" }